// extracted by mini-css-extract-plugin
export default {"EmployeeMenu":"employeeMenu_EmployeeMenu__2JS0J","EmployeeMenuLine":"employeeMenu_EmployeeMenuLine__+DFsa"};